var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"05nPd_i9S95D-ItRZ4gCy"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/recruiter/rec-20260128-15-58";

import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

// Disable Sentry if NEXT_PUBLIC_SENTRY_ENABLED is set to "false" or "0"
// Set NEXT_PUBLIC_SENTRY_ENABLED=false in .env.local to disable Sentry locally
const isSentryEnabled = process.env.NEXT_PUBLIC_SENTRY_ENABLED === "true";

if (!SENTRY_DSN || !isSentryEnabled) {
  // eslint-disable-next-line no-console
  console.log("🚫 Sentry is disabled:");
} else {
  Sentry.init({
    dsn: SENTRY_DSN,

    ignoreErrors: [
      "Cannot read properties of undefined (reading 'onApiResponse')",
    ],

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.02,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    // Enable automatic error tracking
    environment: process.env.NODE_ENV || "development"
  });
}
